let config = {};

// apisllk.kjlke.com  开发
// testapisllk.kjlke.com     测试
// productapisllk.kjlke.com  正式
config.Domain = 'http://testapisllk.kjlke.com/v1/admin/';
// if (process.env.NODE_ENV === 'production') {
//     config.Domain = 'http://testapisllk.kjlke.com/v1/admin/';
// } else {
//     config.Domain = 'http://testapisllk.kjlke.com/v1/admin/';
// }
export default config